export default "__VITE_ASSET__BFYO7Pr___"